<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">트랩 정보</div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button class="mr-r4" size="mini" type="primary" @click="onSaveFormButton" :disabled="disableButtons">저장</el-button>
        <el-button class="mr-r4" size="mini" @click="onCancelFormButton" :disabled="disableButtons">취소</el-button>
      </div>
    </el-row>
    <el-row class="form-list mr-b30" type="flex" justify="space-between">
      <el-col :span="12" class="mr-r20">
        <el-form ref="form" label-position="left">
          <el-form-item label="OID" label-width="100px">{{getValue(trapInformation.snmptrapOid)}}</el-form-item>
          <el-form-item label="버전" label-width="100px">{{getValue(trapInformation.snmptrapVersion)}}</el-form-item>
          <el-form-item label="Generic 타입" label-width="100px">{{getValue(trapInformation.snmptrapGenericName)}}</el-form-item>
          <el-form-item label="Specific 타입" label-width="100px">{{getSpecificIdValue(trapInformation.snmptrapSpecificId)}}</el-form-item>
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form ref="form" label-position="left">
          <el-form-item label="트랩명" label-width="100px">
            <el-input v-model="trapInformation.snmptrapName" @keyup.native="changeDifferenceFormFlag" :disabled="!selectedRow" />
          </el-form-item>
          <el-form-item label="트랩 메시지" label-width="100px">
            <el-row>
              <el-col>
                <el-input v-model="trapInformation.eventMessage" @keyup.native="changeDifferenceFormFlag" :disabled="!selectedRow" />
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="설명" label-width="100px">
            <el-input v-model="trapInformation.oidDescr" rows="1" type="textarea" resize="none" :disabled="!selectedRow"
            @keyup.native="changeDifferenceFormFlag" />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">Sub OID</div>
        <div class="setting-addel">
          <!-- add 1210 height ie friendly -->
          <el-button size="mini" style="height:27px" @click="addSubOid" :disabled="!selectedRow"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" style="height:27px" @click="deleteSubOid" :disabled="checkedRow.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box" align="right">
        <el-button class="mr-r4" size="mini" type="primary" :disabled="!checkDifferenceSuboidDataFlag" @click="onSaveTableButton">저장</el-button>
        <el-button class="mr-r4" size="mini" :disabled="!checkDifferenceSuboidDataFlag" @click="onCancelTableButton">취소</el-button>
        <w-header-search-button @click="toggleSearchTool"/>
      </div>
    </el-row>
    <el-row>
      <!-- add 1210 display-exceptional ie friendly -->
      <el-table-wrapper :column-default="columnDefault" :data="suboidDatas" :columns="columns" highlight-current-row :show-custom-header="true" :show-search-tool="showSearchTool"
      row-class-name="c-dblclick display-exceptional" @row-dblclick="onRowDblclick" @selection-change="onSelectionChange">
        <template slot-scope="scope" slot="message-flag">
          <div align="center">
            <el-checkbox v-model="scope.row.messageFlag" true-label="Y" false-label="N" @change="changeDifferenceDataFlag"/>
          </div>
        </template>
      </el-table-wrapper>
    </el-row>
    <w-suboid-setting-popup title="Sub OID 추가" ref="addSuboidPopup" :oid-data="selectedRow" :suboid-table-datas="suboidDatas"
    @update-suboid-inform="updateSuboidInform" />
    <w-suboid-setting-popup title="Sub OID 수정" ref="updateSuboidPopup" :oid-data="selectedRow" :suboid-data="selectedSuboid" :suboid-table-datas="suboidDatas"
    @update-suboid-inform="updateSuboidInform"
    @delete-suboid-inform="deleteSuboidInform"/>
  </div>
</template>

<script>
import { isEmpty, isEqual, differenceWith, cloneDeep, forEach, isNil } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import msgUtils from '@/utils/message';
import snmptrapSettingAPI from '@/api/settings/log/snmptrap-settings';
import WSuboidSettingPopup from '../popup/SuboidSettingPopup';

export default {
  name: 'WTrapDetailForm',
  components: {
    WSuboidSettingPopup,
  },
  props: {
    selectedRow: {
      type: Object,
    },
  },
  data() {
    const columns = [
      {
        align: 'center',
        type: 'selection',
        width: '40',
      },
      {
        prop: 'snmpOid',
        label: 'OID',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'oidName',
        label: 'OID명',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'oidDescr',
        label: '설명',
        width: '300px',
        searchable: true,
        sortable: true,
        formatter: this.getStringFormatter,
      },
      {
        prop: 'messageFlag',
        label: '메시지 사용 여부',
        width: '130px',
        scopedSlot: 'message-flag',
      },
    ];
    return {
      showSearchTool: false,
      trapInformation: {},
      trapOriginInformation: {},
      suboidDatas: [],
      suboidOriginDatas: [],
      selectedSuboid: {},
      columns,
      checkedRow: [],
      checkDifferenceSuboidDataFlag: false,
      checkDifferenceTrapInformFlag: false,
      columnDefault,
    };
  },
  watch: {
    /**
     * Snmptrap 목록에서 선택된 row
     * @type {Object}
     */
    selectedRow: {
      immediate: true,
      handler() {
        if (!isEmpty(this.selectedRow)) {
          this.trapInformation = cloneDeep(this.selectedRow);
          this.trapOriginInformation = cloneDeep(this.selectedRow);
          this.loadData();
        } else {
          this.trapInformation = {};
          this.trapOriginInformation = {};
          this.suboidDatas = [];
          this.suboidOriginDatas = [];
        }
      },
    },
  },
  computed: {
    disableButtons() {
      if (isEmpty(this.selectedRow)) {
        return true;
      } else if (!this.checkDifferenceTrapInformFlag) {
        return true;
      }
      return false;
    },
  },
  methods: {
    /**
     * Suboid 테이블의 데이터를 불러온다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    loadData() {
      const params = {
        params: {
          snmptrapVersion: this.trapInformation.snmptrapVersion,
          snmptrapOid: this.trapInformation.snmptrapOid,
        },
      };
      snmptrapSettingAPI.getSubOidList(params).then((response) => {
        if (response.data.success) {
          this.suboidDatas = cloneDeep(response.data.data);
          this.suboidOriginDatas = cloneDeep(response.data.data);
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.VIEW, 'Sub Oid', false));
        throw new Error(e);
      });
    },
    getValue(value) {
      return this.getStringFormatter(null, null, value);
    },
    getStringFormatter(row, column, value) {
      return isEmpty(value) ? EMPTY_TEXT : value;
    },
    getSpecificIdValue(value) {
      return isNil(value) || value === -1 ? EMPTY_TEXT : value;
    },
    /**
     * SubOid 추가 팝업을 띄운다.
     * @author Minyeong
     */
    addSubOid() {
      this.$refs.addSuboidPopup.$refs.slidingPopup.open();
    },
    /**
     * 체크박스로 선택된 SubOid들을 삭제한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    deleteSubOid() {
      this.$confirm(...msgUtils.getBasicConfirmData('Sub OID를 삭제')).then(() => {
        snmptrapSettingAPI.deleteSubOid(this.checkedRow).then((response) => {
          if (response.data.success) {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, 'Sub OID', response.data.success));
            this.loadData();
          } else {
            this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, 'Sub OID', response.data.success));
          }
        }).catch((e) => {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.DELETE, 'Sub OID', false));
          throw new Error(e);
        });
      }).catch();
    },
    /**
     * Suboid 수정 팝업을 띄운다.
     * @author Minyeong
     * @param  {[type]} row [description]
     * @return {[type]}     [description]
     */
    onRowDblclick(row) {
      this.selectedSuboid = row;
      this.$refs.updateSuboidPopup.$refs.slidingPopup.open();
    },
    deleteSuboidInform() {
      this.selectedSuboid = {};
    },
    updateSuboidInform() {
      this.loadData();
    },
    onSelectionChange(selection) {
      this.checkedRow = selection;
    },
    /**
     * SubOID 데이터가 수정되었을 때 저장/취소 버튼 활성화/비활성화 여부를 재설정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    changeDifferenceDataFlag() {
      this.checkDifferenceSuboidDataFlag = !isEqual(this.suboidDatas, this.suboidOriginDatas);
    },
    /**
     * Trap 정보의 폼이 수정되었을 때 저장/취소 버튼 활성화/비활성화 여부를 재설정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    changeDifferenceFormFlag() {
      forEach(this.trapInformation, (value, key) => {
        if ((isNil(value))) {
          delete this.trapInformation[key];
        }
      });
      forEach(this.trapOriginInformation, (value, key) => {
        if (isNil(value)) {
          delete this.trapOriginInformation[key];
        }
      });
      this.checkDifferenceTrapInformFlag = !isEqual(this.trapInformation, this.trapOriginInformation);
    },
    /**
     * Snmptrap의 트랩명, 트랩 설명, 메시지를 수정한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveFormButton() {
      snmptrapSettingAPI.updateSnmptrap(this.trapInformation).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
          this.$emit('update-trap-inform');
          this.trapInformation = cloneDeep(this.selectedRow);
          this.trapOriginInformation = cloneDeep(this.selectedRow);
          this.checkDifferenceTrapInformFlag = false;
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
        }
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', false));
        throw new Error(e);
      });
    },
    /**
     * SubOid의 메시지 수집 여부를 저장한다.
     * @author Minyeong
     * @return {[type]} [description]
     */
    onSaveTableButton() {
      const params = differenceWith(this.suboidDatas, this.suboidOriginDatas, isEqual);
      snmptrapSettingAPI.updateMsgFlagSubOid(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
          this.loadData();
        } else {
          this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', response.data.success));
        }
        this.checkDifferenceSuboidDataFlag = false;
      }).catch((e) => {
        this.$message(msgUtils.getResultMsgData(msgUtils.action.SAVE, '변경사항', false));
        throw new Error(e);
      });
    },
    onCancelTableButton() {
      this.suboidDatas = cloneDeep(this.suboidOriginDatas);
      this.changeDifferenceDataFlag();
    },
    onCancelFormButton() {
      this.trapInformation = cloneDeep(this.trapOriginInformation);
      this.changeDifferenceFormFlag();
    },
    toggleSearchTool() {
      this.showSearchTool = !this.showSearchTool;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log/SnmpTrap/components/TrapDetailForm.vue